import { nanoid } from "nanoid/async";
import fetcher from "../api/swr_fetcher";

export const updateFreshchatRestoreId = (customId, restoreId) => {
  fetcher("/v1/um/freshChat", {
    method: "POST",
    body: { customId: customId, restoreId: restoreId },
  })
    .then((res) => {})
    .catch((err) => {});
};

export const fetchFreshchatData = () => {
  return fetcher("/v1/um/freshChat")
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteFreshchat = async () => {
  window.fcWidget.user.clear();
  window.fcWidget.destroy();
};

export const initFreshchatSession = async (
  loginId = null,
  restoreId = null,
  cb = () => {}
) => {
  // console.log(loginId, restoreId);
  // if (loginId != null) {
  //   await deleteFreshchat();
  // }
  let hideChatButton = false;
  let pathnames = [
    "/",
    "/createacc",
    "/forgotpassword",
    "/login",
    "/contactus",
    "/careers",
    "/aboutus",
    "/bugbounty",
    "/feespage",
    "/tandc",
    "/privacy",
    "/aml",
  ];

  if (
    window.innerWidth < 768 &&
    !pathnames.find((ele) => ele.includes(window.location.pathname))
  ) {
    hideChatButton = true;
  }

  window.fcWidget.init({
    config: {
      headerProperty: {
        hideChatButton: hideChatButton,
      },
    },
    token: "bbfebfe2-8af0-4131-82f2-1c7d8236b82b",
    host: "https://wchat.freshchat.com",
    externalId: loginId ? loginId : null,
    restoreId: restoreId ? restoreId : null,
    onInit: cb(),
  });
};

export const detectIfFreshchatHasLoaded = () => {
  if (document.querySelector("#fc_frame, #fc_frame.fc-widget-normal")) {
    return true;
  } else {
    return false;
  }
};

export const hideFreshchatInMobile = () => {
  if (window.innerWidth < 768) {
    let timer = 1;

    let interval = setInterval(() => {
      timer++;

      if (detectIfFreshchatHasLoaded()) {
        document.querySelector(
          "#fc_frame, #fc_frame.fc-widget-normal"
        ).style.display = "none";

        clearInterval(interval);
      } else {
        if (timer >= 10) {
          clearInterval(interval);
        }
      }
    }, 500);
  }
};
